import {LevelInputProps} from '../LevelInputProps';
import {DEFAULT_STEP, resolveLevel} from './resolveLevel';
import {snapLevel} from './snapLevel';

/**
 * Clamps and snaps an arbitrary reading against the bounds and step a gauge was
 * configured with. A nullish reading stays "not recorded" and is never coerced
 * to the minimum.
 */
export function snapLevelToProps(value: number | null, props: LevelInputProps) {
  const {min, max} = resolveLevel(props.value, props.min, props.max);

  return snapLevel(value, min, max, props.step ?? DEFAULT_STEP);
}
